import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiDownload } from 'react-icons/fi';

const TimeoutScreen = () => {
  const navigate = useNavigate();

  const handleDownload = () => {
    const summary = `✨ Chat Summary ✨

- Kumar welcomed the user with a warm intro
- Explored interests and generated career suggestions
- Walked through a roadmap and recommended skills
- Discussed future self, soft skills, and startup ideas

Come back tomorrow to go even further! 💪`;

    const blob = new Blob([summary], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'chat-summary.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    navigate('/review');

    setTimeout(() => {
      navigate("/timeout"); // or render <TimeoutScreen />
    }, 6 * 60 * 1000); // 6 minutes
    
  };

  return (
    <div className="flex justify-center items-center min-h-[80vh] w-full px-4 py-12">
      <div className="w-full max-w-[500px] bg-white rounded-[30px] shadow-xl p-8 text-center flex flex-col gap-6">
        <h2 className="text-3xl sm:text-4xl font-bold font-syne text-stone-800">
          Hey da, time’s up for today! ⏳
        </h2>
        <p className="text-sm sm:text-base text-gray-700 font-medium">
          But look at everything you explored. That’s solid progress. 🔥
        </p>

        {/* Summary Box */}
        <div className="bg-white rounded-2xl p-6 shadow-inner border border-gray-200">
          <p className="text-sm sm:text-base font-bold mb-2">
            ✨ Here’s a quick summary of what we covered together
          </p>
          <p className="text-xs sm:text-sm text-gray-600">
            Download it, reflect on it, or just come back tomorrow ready to grow even more.
          </p>

          <button
            onClick={handleDownload}
            className="mt-4 px-6 py-3 w-full bg-orange-500 hover:bg-orange-600 transition text-white font-bold text-sm sm:text-base rounded-xl flex items-center justify-center gap-2"
          >
            <FiDownload size={18} /> Chat Summary
          </button>
        </div>

        <p className="text-sm font-bold text-orange-700">
          You’re doing amazing, one step at a time. Your future self is proud. 🫶
        </p>
      </div>
    </div>
  );
};

export default TimeoutScreen;
